export enum HeaderActionsEnum {
  SET_IS_STICKED = 'SET_IS_STICKED',
  SET_IS_DIRTY_RESULT_DECISION = 'SET_IS_DIRTY_RESULT_DECISION',
  SET_IS_DIRTY_ACT = 'SET_IS_DIRTY_ACT',
  SET_IS_DIRTY_AGREEMENT = 'SET_IS_DIRTY_AGREEMENT',
  SET_INIT_HASH = 'SET_INIT_HASH',
}
